import React, { type FC } from "react";

import { cn } from "@utilities/helper";

const LogoutIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    className={cn("rtl:-scale-x-100", className)}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8073 22.5767V23.915C11.8073 24.9882 11.2724 25.9147 10.343 26.4512C9.89582 26.7094 9.39672 26.8534 8.87926 26.8537C8.36133 26.8539 7.86239 26.7096 7.4149 26.4512L1.46431 23.0156C0.534765 22.479 0 21.5527 0 20.4794V2.92862C0 1.31368 1.31373 0 2.92862 0H16.034C17.649 0 18.9628 1.31357 18.9628 2.92862V6.62828C18.9628 7.159 18.5319 7.58992 18.0012 7.58992C17.4703 7.58992 17.0397 7.15906 17.0397 6.62828V2.92862C17.0397 2.37408 16.5885 1.92287 16.034 1.92287H4.55027L10.343 5.26787C11.2721 5.80442 11.8073 6.73066 11.8073 7.8036V20.6536H16.034C16.5884 20.6536 17.0397 20.2027 17.0397 19.6481V16.4049C17.0397 15.8738 17.47 15.4432 18.0012 15.4432C18.5321 15.4432 18.9628 15.8739 18.9628 16.4049V19.6481C18.9628 21.2631 17.649 22.5767 16.034 22.5767H11.8073ZM20.7174 12.2498L19.6584 13.3087C19.2829 13.6842 19.283 14.2929 19.6584 14.6685C19.7476 14.7578 19.8536 14.8287 19.9703 14.877C20.087 14.9252 20.212 14.95 20.3383 14.9498C20.4646 14.9501 20.5897 14.9253 20.7065 14.877C20.8232 14.8288 20.9292 14.7579 21.0185 14.6685L23.7185 11.968C24.0938 11.5926 24.0939 10.9842 23.7185 10.6087L21.0185 7.9087C20.6429 7.53317 20.0342 7.53333 19.6585 7.90865C19.2831 8.28376 19.2832 8.89274 19.6585 9.26796L20.7174 10.3267H13.6232C13.092 10.3267 12.6618 10.7572 12.6618 11.2884C12.6618 11.8196 13.092 12.2498 13.6232 12.2498H20.7174V12.2498Z"
      fill="inherit"
    />
  </svg>
);

export default LogoutIcon;
